import axios from "axios";
import {API} from "../config";

const path = "/membro-equipe-servico-acolhimento";
const subPath = "/servico-acolhimento";

class EquipeSAService {
  novoMembroSA(id, membroSA){
    return axios.post(API + path + subPath + `/${id}`, membroSA);
  }

  getEquipeSA(id){
    return axios.get(API + path + subPath + `/${id}`)
  }

  atualizarMembroSA(id, membroSA){
    return axios.put(API + path + `/${id}`, membroSA);
  }

  getMembroEquipe(id){
    return axios.get(API + path + `/${id}`)
  }

  listarMembrosEquipe(){
    return axios.get(API + path)
  }

  listarTiposEquipeSA(){
    return axios.get(API +`/tipo-equipe-servico-acolhimento`);
  }

  listarFuncoesEquipeSA(id){
    return axios.get(API +`/funcao-equipe-acolhimento/${id}`);
  }

  listarCargosEquipeSA(){
    return axios.get(API +`/cargo-equipe-acolhimento`);
  }

  listarRegimePlantaoEquipeSA(){
    return axios.get(API +`/regime-plantao-acolhimento`);
  }

  listarRegimeTrabalhoEquipeSA(){
    return axios.get(API +`/regime-trabalho-acolhimento`);
  }

  desligarMembroSA(id, dataDesligamento){
    return axios.post(API + path + `/desligar/${id}`, {}, {
      params: {
        dataDesligamento
      }
    });
  }
}
const instanceEquipeSA= new EquipeSAService();
export default instanceEquipeSA;